<!--<div class="menu no-selected-catalog" *ngIf="(catalogs$ | async).length === 0">-->
<!--  No currently selected catalog-->
<!--</div>-->

<div class="menu preferences">
  <div class="menu-header">
    <h3 class="menu-block-title"><i class="fa fa-arrow-left"></i> {{ 'DASHBOARD' | translate }}</h3>
  </div>

  <div class="card" [ngClass]="{ active: currentPage === 'general' }">
    <div role="tab" class="card-header">
      <h5>
        <button class="btn btn-link" (click)="goToPage('general')">
          <div class="tab">
            <span class="icon"><i class="fa fa-plus"></i></span>
            <span>{{ 'GENERAL_PREFERENCES' | translate }}</span>
          </div>
        </button>
      </h5>
    </div>
  </div>

  <div class="card" [ngClass]="{ active: currentPage === 'langs' }">
    <div role="tab" class="card-header">
      <h5>
        <button class="btn btn-link" (click)="goToPage('langs')">
          <div class="tab">
            <span class="icon"><i class="fa fa-plus"></i></span>
            <span>{{ 'LANGUAGE_SELECTION' | translate }}</span>
          </div>
        </button>
      </h5>
    </div>
  </div>

  <div class="card" [ngClass]="{ active: currentPage === 'socials' }">
    <div role="tab" class="card-header">
      <h5>
        <button class="btn btn-link" (click)="goToPage('socials')">
          <div class="tab">
            <span class="icon"><i class="fa fa-plus"></i></span>
            <span>{{ 'SOCIAL_NETWORKS' | translate }}</span>
          </div>
        </button>
      </h5>
    </div>
  </div>

  <div class="card" [ngClass]="{ active: currentPage === 'version' }">
    <div role="tab" class="card-header">
      <h5>
        <button class="btn btn-link" (click)="goToPage('version')">
          <div class="tab">
            <span class="icon"><i class="fa fa-plus"></i></span>
            <span>{{ 'VERSION' | translate }}</span>
          </div>
        </button>
      </h5>
    </div>
  </div>

  <div class="card" [ngClass]="{ active: currentPage === 'advanced' }">
    <div role="tab" class="card-header">
      <h5>
        <button class="btn btn-link" (click)="goToPage('advanced')">
          <div class="tab">
            <span class="icon"><i class="fa fa-plus"></i></span>
            <span>{{ 'ADVANCED_FEATURES' | translate }}</span>
          </div>
        </button>
      </h5>
    </div>
  </div>

  <div class="main-menu-footer-logo">
    <img
      class="logo-relaxnews"
      src="assets/images/logos/menu-footer-logo/relaxnews.svg"
      alt="logo Relaxnews"
      title="logo Relaxnews"
    />
    <img
      class="logo-publicis"
      src="assets/images/logos/menu-footer-logo/publicis-media.svg"
      alt="logo Publicis Media"
      title="logo Publicis Media"
    />
    <img class="logo-afp" src="assets/images/logos/menu-footer-logo/AFP.png" alt="logo AFP" title="logo AFP" />
  </div>
</div>
